import { render, staticRenderFns } from "./Shift4LinkInstall.vue?vue&type=template&id=0b861740&scoped=true"
import script from "./Shift4LinkInstall.vue?vue&type=script&lang=js"
export * from "./Shift4LinkInstall.vue?vue&type=script&lang=js"
import style0 from "./Shift4LinkInstall.vue?vue&type=style&index=0&id=0b861740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b861740",
  null
  
)

export default component.exports